import { render, staticRenderFns } from "./IconPlayLight.vue?vue&type=template&id=1a0ee00d&"
import script from "./IconPlayLight.vue?vue&type=script&lang=js&"
export * from "./IconPlayLight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports